import { Component, OnInit } from '@angular/core';
import { NgModule } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Register } from '../../_models/register';
import { User } from '../../_models/user';
import { Subject } from 'rxjs';
import { Caller } from '../../_models/caller';
import { AlertService } from '../../_services/alert.service';
import { stockTransferMenu } from '../../_models/stockTransferMenu';
@Component({
  selector: 'app-admin-stock-transfer',
  templateUrl: './admin-stock-transfer.component.html',
  styleUrls: ['./admin-stock-transfer.component.css']
})
export class AdminStockTransferComponent implements OnInit {
  stockTransferMainMenu: stockTransferMenu[] = [
    { displayName: "All", tabClicked: "all", orderStatus: "ALL", orderType: "STOCK_TRANSFER", additional: "N" },
    { displayName: "Submitted", tabClicked: "submitted", orderStatus: "SUBMITTED", orderType: "STOCK_TRANSFER", additional: "N" },
    { displayName: "Pick", tabClicked: "pick", orderStatus: "TO_PICK", orderType: "STOCK_TRANSFER", additional: "N" },
    { displayName: "Pack", tabClicked: "pack", orderStatus: "TO_PACK", orderType: "STOCK_TRANSFER", additional: "N" },
    { displayName: "Ready to Ship", tabClicked: "readyToShip", orderStatus: "READY_TO_SHIP", orderType: "STOCK_TRANSFER", additional: "N" },
    { displayName: "Awaiting Carrier", tabClicked: "awaitingCarrier", orderStatus: "AWAITING_CARRIER", orderType: "STOCK_TRANSFER", additional: "Y" },
    { displayName: "Shipped", tabClicked: "shipped", orderStatus: "SHIPPED", orderType: "STOCK_TRANSFER", additional: "Y" },
    { displayName: "Arrived", tabClicked: "arrived", orderStatus: "ARRIVED", orderType: "STOCK_TRANSFER", additional: "Y" },
    { displayName: "Partially Received", tabClicked: "partiallyReceived", orderStatus: "PARTIALLY_RECEIVED", orderType: "STOCK_TRANSFER", additional: "Y" },
    { displayName: "Received", tabClicked: "received", orderStatus: "RECEIVED", orderType: "STOCK_TRANSFER", additional: "Y" },
    { displayName: "Hold", tabClicked: "hold", orderStatus: "ON_HOLD", orderType: "STOCK_TRANSFER", additional: "Y" },
    { displayName: "Cancelled", tabClicked: "cancelled", orderStatus: "CANCELLED", orderType: "STOCK_TRANSFER", additional: "Y" },
    { displayName: "Exception", tabClicked: "exception", orderStatus: "EXCEPTION", orderType: "STOCK_TRANSFER", additional: "Y" }
  ];
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  tabClicked: string = "all";
  warehouses: any;
  warehousesList: string;
  addressText: any;
  selectedWarehouse: any;
  warehouseSelected: any;
  owner: number;
  status: any;
  noOfBoxesArray = [];
  stockTransferList: any;
  checkedList: any;
  masterSelected: boolean = false;
  errorMessage: string;
  totalRecords: number;
  previousStatus = '';
  assignValue: any;
  userList: any;
  modalPickLine: any = {};
  popUpAssign: string = 'N';
  popUpGenerate: string = 'N';
  pickSlipPopUp: string = 'N';
  popUpArrived: string = 'N';
  orderStatus: any = 'ALL';
  userDrop: string;
  statusText1: string = "";
  statusText2: string = "";
  grant: any;
  userDrop2: string;
  assignedId: string;
  assignIdError: string;
  myAngularxQrCode: string = null;
  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private api: ApiIntegration, private g: Globals, public user: User, public caller: Caller, public register: Register) {
    this.g.page = "Receiving Orders";
    // this.getStockListByStatus("ALL");
    this.populateTabData('all', 'ALL');
    // this.getAdminStockTransferHeadersList('ALL');
  }
  /*      getAdminStockTransferHeadersList(orderStatus){
        this.g.loaderDisplay="display";
              this.api.getAdminStockTransferHeadersList(orderStatus,"STOCK_TRANSFER","1").subscribe((data:any)=> {
              this.g.loaderDisplay = "";
            this.stockTransferList= data;
               }, err=> {
               this.g.loaderDisplay="";
                this.alertService.error('Error',err);});

  }*/

  switchPosition(om) {
    let index = this.stockTransferMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.stockTransferMainMenu[4].displayName) {
      this.stockTransferMainMenu[4].additional = 'Y';
    }
    var tmp = 5;
    for (let o of this.stockTransferMainMenu) {
      if (tmp < this.stockTransferMainMenu.length) {
        if (om.displayName !== this.stockTransferMainMenu[tmp].displayName) {
          this.stockTransferMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }
  getAllAdminUsers() {
    this.api.getAllAdminUsers("1", "ACTIVE").subscribe((data: any) => {
      this.userList = data;
      this.rerender();
    }, err => {
      this.alertService.error('Error', err);
    });
  }
  populate(orderChange) {

    this.api.getAdminStockTransferHeadersList(orderChange, "STOCK_TRANSFER", "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.stockTransferList = data.ordersData;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });

  }

  populateTabData(triggered, orderStatus) {
    this.tabClicked = triggered;
    this.orderStatus = orderStatus;
    if (!this.previousStatus) {
      this.getStockListByStatus(orderStatus);
    } else {
      this.rerender();
    }

  }
  arrived() {

    this.assignIdError = "";
    if (this.assignedId === null || this.assignedId === undefined || this.assignedId === '' || this.assignedId === 'undefined') {
      this.assignIdError = 'Please enter Id';
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateStockTransferH&L', {
      "stockTransferHeaderId": this.assignValue.stockTransferHeaderId,
      "orderStatus": "ARRIVED",
      "organizationId": 1,
      "shippingBarCodeValue": this.assignedId
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Stock Transfer', 'Arrived Successfully');
          this.populateTabData('in_transit', "IN_TRANSIT")
          this.closePopUpForArrived();
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
  getStockListByStatus(status) {

    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      language: {
        searchPlaceholder: 'Search by Order Number'
      },
      serverSide: true,
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.orderStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.orderStatus;
        }
        let query: any = {
          orderStatus: this.orderStatus,
          orderType: 'STOCK_TRANSFER',
          organizationId: 1,
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        let apiMethod = "api/getStockTransferHeadersList";
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        this.g.loaderDisplay = "display";
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.stockTransferList = resp.ordersData;
            this.g.loaderDisplay = "";
            this.totalRecords = resp.noOfOrders;
            this.stockTransferList.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfOrders,
              recordsFiltered: resp.noOfOrders
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };
  }


  checkUncheckAll() {
    for (var i = 0; i < this.stockTransferList.length; i++) {
      this.stockTransferList[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  selectShip(sl) {
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.stockTransferList.length; i++) {
      if (this.stockTransferList[i].isSelected) {
        this.checkedList.push(this.stockTransferList[i]['stockTransferHeaderId']);
      }
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }

  tabChange() {
    this.checkedList = [];
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }


  editStock(stockTransferList) {

    this.checkedList = [];

    let i = 0;
    let ohid;
    for (let stock of stockTransferList) {
      if (stock.isSelected) {
        i = i + 1;
        ohid = stock.stockTransferHeaderId;
      }
    };
    if (i === 1) {
      this.router.navigate(['/admin/processingStockTransfers/' + ohid]);
    } else {
      this.errorMessage = "Can not Edit multiple Stock at once. Please select one at a time";
    }
  }
  shipMultipleStockTransfer(stockTransferList) {
    let i = 0;
    let ohid;
    for (let stock of stockTransferList) {
      if (stock.isSelected) {
        i = i + 1;
        ohid = stock.stockTransferHeaderId;
      }
    };
    if (i === 1) {
      this.router.navigate(['/admin/processingStockTransfers/' + ohid]);
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }

  ngOnInit(): void {
    // this.dtOptions = {
    //            pagingType: 'full_numbers',
    //            lengthMenu :[20, 50, 100, 200],
    //            pageLength: 20
    // };
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }
  shipMultipleOrders(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order.stockTransferHeaderId;
      }
    };
    if (i === 1) {
      this.router.navigate(['/admin/processingStockTransfers/' + ohid]);
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }
  submitAdmin() {
    this.caller.parent = "STOCK";
    if (this.user.role === 'ROLE_ADMIN') {
      this.router.navigate(['/admin/accountOwner']);
    } else {
      this.router.navigate(['/admin/stockEntryCreate']);
    }
  }

  pickMultipleOrders(stockTransferList) {
    this.checkedList = [];
    for (let stockTranfer of stockTransferList) {
      if (stockTranfer.isSelected) {
        this.toPick(stockTranfer);
      }
    };
  }

  toPick(st) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateStockTransferH&L', {
      "orderStatus": "TO_PICK",
      "organizationId": 1,
      "stockTransferHeaderId": st.stockTransferHeaderId
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Stock Transfer', 'Pick Successfully');

          let index = this.stockTransferList.indexOf(st);
          this.stockTransferList.splice(index, 1);
          this.rerender();
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  selectGeneratePickSlip(stockTransferList) {
    let i = 0;
    let ohid = {};
    for (let stockTranfer of stockTransferList) {
      if (stockTranfer.isSelected) {
        i = i + 1;
        ohid = stockTranfer;
      }
    };
    if (i === 1) {
      this.pickDetailes(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Orders at once. Please select one at a time";
    }
  }

  closePickSlipPop() {
    this.pickSlipPopUp = 'N';
    this.errorMessage = "";
  }

  pickDetailes(pickLine) {

    this.api.getGeneratedPickSlipForStockTransferHeader("1", pickLine.stockTransferHeaderId).subscribe((data: any) => {
      this.pickSlipPopUp = 'Y';
      this.modalPickLine = data;
      this.rerender();
    }, err => {
      this.alertService.error('Error', err);
    });

  }

  moveToHold(stockTransferList) {
    this.checkedList = [];
    for (let stockTranfer of stockTransferList) {
      if (stockTranfer.isSelected) {
        this.moveHold(stockTranfer);
      }
    };
  }

  moveToShipped(orders) {
    let i = 0;
    let ohid = {};
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    };
    if (i === 1) {
      this.shipping(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Shipments at once. Please select one at a time";
    }
  }
  returnOrders(orders) {
    this.router.navigate(['/admin/returnOrder/' + this.checkedList[0]]);
  }

  shipping(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateStockTransferH&L', {
      "stockTransferHeaderId": ord.stockTransferHeaderId,
      "orderStatus": "DELIVERED",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Delivered Successfully');

          let index = this.stockTransferList.indexOf(ord);
          this.stockTransferList.splice(index, 1);
          this.rerender();
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  moveHold(st) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateStockTransferH&L', {
      "orderStatus": "ON_HOLD",
      "organizationId": 1,
      "stockTransferHeaderId": st.stockTransferHeaderId
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Stock Transfer', 'Pick Successfully');

          let index = this.stockTransferList.indexOf(st);
          this.stockTransferList.splice(index, 1);
          this.rerender();
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  cancelOrder(stockTransferList) {
    this.checkedList = [];
    for (let stockTranfer of stockTransferList) {
      if (stockTranfer.isSelected) {
        this.moveCancel(stockTranfer);
      }
    };
  }

  moveCancel(st) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateStockTransferH&L', {
      "orderStatus": "CANCELLED",
      "organizationId": 1,
      "stockTransferHeaderId": st.stockTransferHeaderId
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Stock Transfer', 'Pick Successfully');

          let index = this.stockTransferList.indexOf(st);
          this.stockTransferList.splice(index, 1);
          this.rerender();
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  assignedPick(orders) {
    let i = 0;
    let ohid = {};
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    };
    if (i === 1) {
      this.assignedPopUp(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Shipments at once. Please select one at a time";
    }
  }
  selectArrived(orders) {
    let i = 0;
    let ohid = {};
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    };
    if (i === 1) {
      this.assignedPopUpForArrived(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Shipments at once. Please select one at a time";
    }
  }
  assignedPopUp(p) {
    this.getAllAdminUsers();
    this.assignValue = p;
    this.popUpAssign = 'Y';
    //this.statusText1 = "";

  }
  assignedPopUpForArrived(t) {
    this.assignValue = t;
    this.popUpArrived = 'Y';
  }
  moveToException(stockTransferList) {
    this.checkedList = [];
    for (let stockTranfer of stockTransferList) {
      if (stockTranfer.isSelected) {
        this.moveException(stockTranfer);
      }
    };
  }
  closePopUpForArrived() {
    this.popUpArrived = 'N';
    this.assignedId = "";
    this.assignIdError = "";
  }
  moveException(st) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateStockTransferH&L', {
      "orderStatus": "EXCEPTION",
      "organizationId": 1,
      "stockTransferHeaderId": st.stockTransferHeaderId
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Stock Transfer', 'Pick Successfully');

          let index = this.stockTransferList.indexOf(st);
          this.stockTransferList.splice(index, 1);
          this.rerender();
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
  closePopUp() {
    this.popUpAssign = 'N';
    //this.shipmentNumber = "";
    //this.statusText1 = "";

  }
  submitAssign() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/toAssignStockTransferHeader',
      {
        "orderStatus": "PICK_ASSIGNED",
        "orgUserId": this.userDrop,
        "organizationId": 1,
        "stockTransferHeaderId": this.assignValue.stockTransferHeaderId
      },

      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Assigned Status', 'Submitted  Successfully');

          this.popUpAssign = 'N';
          this.populateTabData('pick', "TO_PICK");
          // this.getOrder("TO_PICK");
          this.closePopUp();

        }
        else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });
  }

  generateShippingLabel(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    };
    if (i === 1) {
      this.generateGrant(ohid);
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }

  closePopUpGenerate() {
    this.popUpGenerate = 'N';
    this.populateTabData('readyToShip', "READY_TO_SHIP");
    // this.getOrder("READY_TO_SHIP");
  }
  generateGrant(selectedOrder) {
    if (selectedOrder.shippingOption !== "THIRD_PARTY") {
      this.api.generateShippingLabelForStockTransfer(selectedOrder.stockTransferHeaderId, "1").subscribe((data: any) => {
        this.popUpGenerate = 'Y';
        this.grant = data;
        this.noOfBoxesArray = [];
        if (this.grant.orderLinesList[0].packingConfigList.length && this.grant.orderLinesList[0].packingConfigList[0].noOfBoxes) {
          for (let i = 0; i < this.grant.orderLinesList[0].packingConfigList[0].noOfBoxes; i++) {
            this.noOfBoxesArray.push(i + 1);
          }
        }
        else {
          this.noOfBoxesArray = [1];
        }

        this.myAngularxQrCode = this.grant.orderNumber
        this.rerender();

      }, err => {
        this.alertService.error('Error', err);
      });

    } else {
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
      this.http.post(environment.apiUrl + 'api/getShipLabelStockTransferFrmShipRocket?stockTransferHeaderId=' + selectedOrder.stockTransferHeaderId,
        {},
        { headers: header1 }).subscribe(data => {
          this.checkedList = [];
          this.g.loaderDisplay = "";
          if (data['label_created'] == true) {
            this.alertService.success('Label Generated', 'Proceed Successfully');
            this.rerender();
          }
          else {
            this.alertService.error('Error', data['message']);
          }
        },
          (err: HttpErrorResponse) => {
            this.g.loaderDisplay = "";
          });

    }
  }
  validToDisplay(status) {
    let disable = true;
    let checkedList = [];
    if (this.stockTransferList && this.stockTransferList.length) {
      for (var i = 0; i < this.stockTransferList.length; i++) {
        if (this.stockTransferList[i].isSelected) {
          checkedList.push(this.stockTransferList[i]);
        }
      }
    }
    if (checkedList.length == 1) {
      if (this.tabClicked === 'submitted') {
        if (status === 'Validated' && checkedList[0].inStockStatus) {
          disable = false;
        } else if (status === 'Low Stock' && !checkedList[0].inStockStatus) {
          disable = false;
        }
      }

      if (this.tabClicked === 'pick') {
        if (status === 'Ready to Pick' && checkedList[0].orderStatus === 'TO_PICK') {
          disable = false;
        }
      }
      if (this.tabClicked === 'readyToShip') {
        if (status === 'Carrier to be assigned' && checkedList[0].orderStatus === 'READY_TO_SHIP') {
          disable = false;
        }
        if (status === 'Generate Label' && checkedList[0].orderStatus === 'GENERATE_LABEL') {
          disable = false;
        }
        if (status === 'Label Generated' && checkedList[0].orderStatus === 'LABEL_GENERATED') {
          disable = false;
        }
      }
      if (this.tabClicked === 'awaitingCarrier') {
        if (status === 'Awaiting Carrier' && checkedList[0].orderStatus === 'AWAITING_CARRIER') {
          disable = false;
        }
        if (status === 'shipped' && checkedList[0].orderStatus === 'SHIPPED') {
          disable = false;
        }
      }
      if (this.tabClicked === 'completed') {
        if (status === 'shipped' && checkedList[0].orderStatus === 'COMPLETED') {
          disable = false;
        }
      }
    } else if (checkedList.length > 1) {
      let i = 0;
      checkedList.forEach((s) => {

        if (this.tabClicked === 'submitted') {
          if (status === 'Validated' && s.inStockStatus) {
            disable = false;
            i = i + 1;
          } else if (status === 'Low Stock' && !s.inStockStatus) {
            disable = false;
            i = i + 1;
          }
          if (i !== checkedList.length) {
            disable = true;
          }
        }
      });
    }
    else {
      disable = true;
    }

    return disable;
  }
  inTransit(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateStockTransferH&L', {
      "stockTransferHeaderId": ord.stockTransferHeaderId,
      "orderStatus": "SHIPPED",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Stock Transfer', 'In shipped Successfully');
          this.populateTabData('awaitingCarrier', "AWAITING_CARRIER");
          // this.getOrder("AWAITING_CARRIER");
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  moveToInTransit(orders) {
    let i = 0;
    let ohid = {};
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    };
    if (i === 1) {
      this.inTransit(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Shipments at once. Please select one at a time";
    }
  }

  selectAwaitingCarrier(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    };
    if (i === 1) {
      this.awaitingCarrierFunction(ohid);
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }


  awaitingCarrierFunction(ord) {

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    if (ord.shippingOption !== "THIRD_PARTY") {
      this.g.loaderDisplay = "display";

      this.http.post(environment.apiUrl + 'api/updateStockTransferH&L', {
        "stockTransferHeaderId": ord.stockTransferHeaderId,//this.route.snapshot.params['id'],
        "orderStatus": "AWAITING_CARRIER",
        "organizationId": 1
      },
        { headers: header1 }).subscribe(data => {
          this.checkedList = [];
          this.g.loaderDisplay = "";
          if (data['code'] == 200) {
            this.alertService.success('Stock Transfer', 'Awaiting Carrier Successfully');

            let index = this.stockTransferList.indexOf(ord);
            this.stockTransferList.splice(index, 1);
            this.rerender();
          }
          else {
            this.alertService.error('Error', data['message']);
          }
        },
          (err: HttpErrorResponse) => {
            this.g.loaderDisplay = "";
          });
    } else {
      this.http.post(environment.apiUrl + 'api/pickUpRequestForStockTransferShip?stockTransferHeaderId=' + ord.stockTransferHeaderId, {}, {
        headers: header1
      }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['pickup_status']) {
          this.alertService.success('PickUp Scheduled On :', data['response'].pickup_scheduled_date);
          let index = this.stockTransferList.indexOf(ord);
          this.stockTransferList.splice(index, 1);
          this.rerender();
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });

    }


  }

}



